var render, staticRenderFns
import script from "./Expand.vue?vue&type=script&lang=js&"
export * from "./Expand.vue?vue&type=script&lang=js&"
import style0 from "./Expand.vue?vue&type=style&index=0&id=e47a4968&scoped=true&lang=css&"
import style1 from "./Expand.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47a4968",
  null
  
)

export default component.exports